export enum DestinoNotaFiscal {
    TodasOpcoes = 0,
    DentroEstado = 1,
    ForaEstado = 2,
    Internacional = 3,
}
